import { render, staticRenderFns } from "./assets.vue?vue&type=template&id=4f230536&"
import script from "./assets.vue?vue&type=script&lang=js&"
export * from "./assets.vue?vue&type=script&lang=js&"
import style0 from "./assets.vue?vue&type=style&index=0&id=4f230536&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports